<!--
* UIID: UI-DLB-MBL-100
* UI Name:  Scanner List
* Modify Date: 2020/07/15
-->
<template>
  <div>
    <v-row no-gutters class="scanner-section">
      <!-- Scanner Data -->
      <v-col
        v-if="this.scannerType === 'FTE'"
        class="pl-0 pb-0 pt-0 pr-12px"
        cols="12"
        lg="6"
        md="6"
      >
        <v-row no-gutters>
          <v-col cols="12" class="scanner-grid-pd zoom-scanner-file">
            <v-row class="v-grid-title row-pd mb-4">
              <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="3">
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <span class="scanner-label">{{ $t('lbl.mapBuilder.scannerTitle') }}</span>
                </div>
              </v-col>
              <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="9">
                <!-- 2022.01.13 213960 SPKA-365 Group 2 buttons to v-menu -->
                <div class="btn-form-control mb-0">
                  <v-menu open-on-hover offset-y>
                    <template v-slot:activator="{ on, attrs, value }">
                      <v-btn class="btn-active btn-browser btn-inline" v-bind="attrs" v-on="on">
                        Load
                        <v-icon :class="value ? 'fa-rotate-180' : ''">
                          mdi mdi-chevron-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <v-list class="map-builder-custom-list">
                      <v-list-item
                        v-for="(item, index) in loadTypes"
                        :key="index"
                        @click="changeLoadType(item)"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <v-btn
                    @click="loadScannerLocal"
                    class="btn-active btn-browser btn-inline"
                  >
                    <v-icon x-small class="mr-1 show-load-icon">fas fa-file-upload</v-icon>
                    <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromLocal')}}</span>
                  </v-btn> -->
                  <input
                    @change="inputScannerFileLocal"
                    id="scanner_data"
                    type="file"
                    ref="scanner_data"
                    style="display: none"
                    accept=".cpp"
                  />
                  <!-- <v-btn
                    @click="openLoadFilePop({mode: 'Load', filetype: 'scanner'})"
                    class="btn-active btn-browser btn-inline"
                  >
                    <v-icon x-small class="mr-1 show-load-icon">fas fa-cloud-download-alt</v-icon>
                    <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromServer')}}</span>
                  </v-btn> -->
                  <v-btn
                    @click="openScannerListDialog"
                    class="btn-active btn-scanner btn-add btn-inline"
                  >
                    <v-icon x-small class="mr-1 show-load-icon">fa fa-list</v-icon>
                    <span class="show-load-txt">{{ $t('btn.mapBuilder.scannerList') }}</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="scanner-icon">
              <v-col class="pa-0 d-inline-flex" cols="12" lg="7" md="6">
                <div class="mapper-file-name" v-if="this.scannerFileName != ''">
                  {{ this.scannerFileName }}
                </div>
                <div class="mapper-file-name map-version mx-2" v-if="version">
                  {{ `v ${version}` }}
                </div>
                <div v-if="this.checkInYN === 'N'" class="mapper-status status-checked-in">
                  {{ $t('btn.mapBuilder.checkedIn') }}
                </div>
                <div v-if="this.checkInYN === 'Y'" class="mapper-status status-checked-out">
                  {{ $t('btn.mapBuilder.checkedOut') }}
                </div>
              </v-col>
              <v-col class="pa-0 text-right btn-expand" cols="12" lg="5" md="6">
                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  transition="scale-transition"
                  origin="left"
                >
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn x-small text icon class="mr-1" v-bind="attrs" v-on="on">
                      <icon-svg iconName="clear" />
                    </v-btn>
                  </template>
                  <v-list dense class="text-xs custom-menu">
                    <v-list-item @click="clearView('scanner')">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('btn.mapBuilder.clear') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="clearTab()">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('btn.mapBuilder.clearAll') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn x-small text icon @click="expandView('scanner')">
                  <icon-svg iconName="expand" />
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="text-view-scanner">
              <div class="CodeMirror">
                <ScannerViewer
                  v-model="scannerFileContent"
                  :options="this.cmOption"
                  @changes="onChangeTextView('scanner')"
                  ref="scannerFile"
                ></ScannerViewer>
              </div>
            </v-row>
            <v-row class="btn-form-control">
              <v-col class="data-query-section pb-0 pt-0 mt-0 text-right" cols="12" lg="12" md="12">
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-autocomplete
                    v-if="isDlb"
                    v-model="libraryVersion"
                    @change="onVersionChange(libraryVersion)"
                    :menu-props="{ offsetY: true }"
                    :items="libraryItem"
                    placeholder="Library"
                    class="custom-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-autocomplete>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex mr-0">
                  <v-btn
                    :disabled="isValidCompile"
                    @click="buildScanner"
                    class="btn-active btn-search mt-0 mb-0"
                  >
                    <!-- <v-icon small class="mr-2">fa fa-cubes</v-icon> -->
                    {{ $t('btn.mapBuilder.compile') }}
                  </v-btn>
                  <v-btn
                    :disabled="isValidExecute"
                    @click="executeScannner"
                    class="btn-active btn-execute"
                  >
                    <!-- <icon-svg iconName="execution"/> -->
                    {{ $t('btn.mapBuilder.execute') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="scanner-icon">
              <v-col class="pa-0" cols="12" lg="10" md="10">
                <div class="file-name">{{ $t('lbl.mapBuilder.resultTitle') }}</div>
              </v-col>
              <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                <v-btn x-small text icon @click="expandView('resultBuild')">
                  <icon-svg iconName="expand" />
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters class="build-result-view">
              <div class="CodeMirror">
                <resultBuildViewer
                  :value="resultMSG"
                  :options="this.buildCmOption"
                  ref="resultBuild"
                ></resultBuildViewer>
              </div>
            </v-row>
            <v-row class="btn-grid no-gutters btn-form-control">
              <v-col cols="12" lg="6" md="6" class="pa-0 pr-3 text-left">
                <v-btn
                  :disabled="isValidScanner"
                  @click="saveScannerFile"
                  class="btn-active btn-search"
                  >{{ $t('btn.common.save') }}</v-btn
                >
                <v-btn
                  :disabled="isValidScanner"
                  @click="openLoadFilePop({ mode: 'Save', filetype: 'scanner' })"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                >
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" lg="6" md="6" class="pa-0 text-right">
                <v-btn
                  :disabled="checkInYN !== 'N'"
                  @click="openCheckOut"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.checkOut') }}</v-btn
                >
                <v-btn
                  :disabled="disableCheckin || checkInYN !== 'Y'"
                  @click="openScannerCheckInDialog"
                  class="btn-active btn-search"
                  >{{ $t('btn.mapBuilder.checkIn') }}</v-btn
                ></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- Scanner EDI Data -->
      <v-col cols="12" md="6" class="pl-0 pb-0 pt-0 pr-12px" v-else>
        <v-row no-gutters>
          <v-col cols="12" class="scanner-grid-pd zoom-scanner-file">
            <v-row class="v- grid-title row-pd mb-2">
              <v-col cols="12" sm="6" class="pa-0">
                <span class="scanner-label">{{ $t('lbl.mapBuilder.scannerTitle') }}</span>
              </v-col>
            </v-row>
            <v-row class="v-grid-title row-pd btn-expand">
              <v-col cols="12" sm="3" md="3" lg="3" class="pa-0">
                <span class="edi-scanner-label">{{ this.scannerType }}</span>
              </v-col>
              <v-col cols="12" sm="7" md="7" lg="8" class="pa-0 text-right">
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-autocomplete
                    v-if="isDlb"
                    v-model="libraryVersion"
                    @change="onVersionChange(libraryVersion)"
                    :menu-props="{ offsetY: true }"
                    :items="libraryItem"
                    placeholder="Library"
                    class="custom-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-autocomplete>
                  <v-btn class="btn-active btn-execute" @click="executeToFlat">
                    <!-- <icon-svg iconName="execution"/> -->
                    {{ $t('btn.mapBuilder.execute') }}
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="2" md="2" lg="1" class="pa-0 text-right btn-edi-expand">
                <v-row no-gutters class="scanner-icon">
                  <v-btn x-small text icon @click="expandView('ediScanner')">
                    <icon-svg iconName="expand" />
                  </v-btn>
                  <v-menu
                    offset-x
                    :close-on-content-click="false"
                    transition="scale-transition"
                    origin="left"
                  >
                    <template v-slot:activator="{ attrs, on }">
                      <v-btn x-small text icon class="mr-1" v-bind="attrs" v-on="on">
                        <icon-svg iconName="clear" />
                      </v-btn>
                    </template>
                    <v-list dense class="text-xs">
                      <v-list-item @click="clearView('ediScanner')">
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('btn.mapBuilder.clear') }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="clearTab()">
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('btn.mapBuilder.clearAll') }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters class="text-view-ediscanner">
              <div class="CodeMirror">
                <ScannerViewer
                  v-model="resultExMSG"
                  :options="this.cmOption"
                  ref="scannerFile"
                ></ScannerViewer>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="6" md="6">
        <v-row no-gutters>
          <!-- Scanner Input Data -->
          <v-col cols="12" xl="6" lg="6" md="6" class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-input-data">
                <v-row class="v-grid-title row-pd mb-4">
                  <v-col class="date-query-section pa-0 mt-0" cols="12" lg="3" md="4">
                    <span class="scanner-label">{{
                      $t('lbl.mapBuilder.scannerInputFileTitle')
                    }}</span>
                  </v-col>
                  <v-col class="date-query-section pa-0 mt-0 text-right" cols="12" lg="9" md="8">
                    <!-- 2022.01.13 213960 SPKA-365 Group 2 buttons to v-menu -->
                    <div class="btn-form-control mb-0">
                      <v-menu open-on-hover offset-y>
                        <template v-slot:activator="{ on, attrs, value }">
                          <v-btn
                            class="btn-active btn-browser btn-inline mr-0"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Load
                            <v-icon :class="value ? 'fa-rotate-180' : ''">
                              mdi mdi-chevron-down
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list class="map-builder-custom-list">
                          <v-list-item
                            v-for="(item, index) in loadTypes"
                            :key="index"
                            @click="changeLoadInputType(item)"
                          >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <!-- <v-btn
                        @click="loadInputLocal"
                        class="btn-active btn-browser btn-inline"
                      >
                        <v-icon x-small class="mr-1 show-load-icon">fas fa-file-upload</v-icon>
                        <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromLocal')}}</span>
                      </v-btn> -->
                      <input
                        @change="inputDataFileLocal"
                        id="input_data"
                        type="file"
                        ref="input_data"
                        style="display: none"
                        accept=".txt, .edi, .json, .xml"
                      />
                      <!-- <v-btn
                        @click="openLoadFilePop({mode: 'Load', filetype: 'input'})"
                        class="btn-active btn-browser btn-inline"
                      >
                        <v-icon x-small class="mr-1 show-load-icon">fas fa-cloud-download-alt</v-icon>
                        <span class="show-load-txt">{{$t('btn.mapBuilder.loadFromServer')}}</span>
                      </v-btn> -->
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters class="scanner-icon">
                  <v-col class="pa-0" cols="12" lg="10" md="10">
                    <div class="file-name" v-if="this.inputFileName != ''">
                      {{ this.inputFileName }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="clearView('input')" class="mr-1">
                      <icon-svg iconName="clear" />
                    </v-btn>
                    <v-btn x-small text icon @click="expandView('input')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-view-input">
                  <div class="CodeMirror">
                    <InputDataViewer
                      v-model="inputFileContent"
                      :options="this.cmOption"
                      @changes="onChangeTextView('input')"
                      ref="inputFile"
                    ></InputDataViewer>
                  </div>
                </v-row>
                <v-row class="btn-grid no-gutters btn-form-control">
                  <v-btn
                    :disabled="isValidSave"
                    @click="saveInputFile"
                    class="btn-active btn-search"
                    >{{ $t('btn.common.save') }}</v-btn
                  >
                  <v-btn
                    :disabled="isValidSave"
                    @click="openLoadFilePop({ mode: 'Save', filetype: 'input' })"
                    class="btn-active btn-search"
                    >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <!-- //BizData -->
          <v-col cols="12" xl="6" lg="6" md="6" class="pt-0 pb-0 pl-12px pr-0">
            <v-row no-gutters>
              <v-col cols="12" class="scanner-grid-pd zoom-biz-file">
                <v-row class="v-grid-title row-pd mb-4">
                  <span class="scanner-label">{{
                    $t('lbl.mapBuilder.scannerOutputFileTitle')
                  }}</span>
                </v-row>
                <v-row no-gutters class="scanner-icon">
                  <v-col class="pa-0 d-inline-flex" cols="12" lg="10" md="10">
                    <div class="file-name" v-if="this.bizFileName != ''">
                      {{ this.bizFileName }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 text-right btn-expand" cols="12" lg="2" md="2">
                    <v-btn x-small text icon @click="clearView('biz')" class="mr-1">
                      <icon-svg iconName="clear" />
                    </v-btn>
                    <v-btn x-small text icon @click="expandView('biz')">
                      <icon-svg iconName="expand" />
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-view-biz">
                  <div class="CodeMirror">
                    <BIZViewer
                      v-model="bizFileContent"
                      :options="this.cmOption"
                      ref="bizFile"
                    ></BIZViewer>
                  </div>
                </v-row>
                <v-row class="btn-grid no-gutters btn-form-control">
                  <v-btn
                    :disabled="isValidBiz"
                    @click="saveBizFile"
                    class="btn-active btn-search"
                    >{{ $t('btn.common.save') }}</v-btn
                  >
                  <v-btn
                    :disabled="isValidBiz"
                    @click="openLoadFilePop({ mode: 'Save', filetype: 'biz' })"
                    class="btn-active btn-search"
                    >{{ $t('btn.mapBuilder.saveAs') }}</v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialogWindow
      ref="validateDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="validateMessage"
    ></dialogWindow>
    <!-- 2020/11/11 203737 Remove unused source
    <dialogWindow
      ref="successDialog"
      size="max"
      color="success"
      :detail="$t('msg.common.saveSuccess', ['File'])"
    ></dialogWindow> -->
    <dialogWindow
      ref="compileWarningDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="$t('msg.mapBuilder.compileWarning')"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.mapBuilder.confirmCheckOut')"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickOkay"
    ></dialogWindow>
  </div>
</template>

<script>
import BIZViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import InputDataViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import ScannerViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import resultBuildViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

import { mapState } from 'vuex';
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';
import 'codemirror/addon/display/fullscreen.js';
import 'codemirror/addon/display/fullscreen.css';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';
import cfg from '@/vue-caas/config/config.js';

// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    InputDataViewer,
    BIZViewer,
    ScannerViewer,
    resultBuildViewer,
    dialogWindow,
    IconSvg,
  },
  computed: {
    ...mapState('mapbuilder', {
      /* 2020/11/11 203737 Remove unused source
      foldList: "foldList",
      fileList: "fileList",*/
      savedFile: 'savedFile',
      buildResult: 'buildResult',
      exeResult: 'exeResult',
      libList: 'libList',
    }),
    ...mapState('common', {
      fileContent: 'fileContent',
    }),
    ...mapState('map', {
      scannerList: 'scannerList',
    }),
    cmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          readOnly: false,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: false,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
      };
    },
    buildCmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: false,
          line: false,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: false,
        line: false,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
      };
    },
    isValidSave() {
      if (this.inputFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidScanner() {
      if (this.scannerFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidBiz() {
      if (this.bizFileContent.toString().trim() != '') {
        return false;
      }
      return true;
    },
    isValidCompile() {
      if (this.scannerFileName != '') {
        return false;
      }
      return true;
    },
    isValidExecute() {
      if (this.buildResultMSG == 'SUCCESS') {
        return false;
      }
      return true;
    },
    isValidExecuteToFlat() {
      if (this.fileID == '') {
        return true;
      }
      return false;
    },
  },
  props: {
    scannerType: String,
    versionList: Object,
  },
  data() {
    return {
      lastFoldIdInput: '',
      lastFoldIdScanner: '',
      tooltipWidth: 300,
      disableCheckin: true,
      accessCheckIn: false,
      tab: null,
      inputFileContent: '',
      inputFileName: '',
      inputFile: '',
      inputFileSize: 0,
      fileID: '',
      inputFolderId: '',
      inputFileExtension: '',
      inputFileNameSave: '',
      scannerFileContent: '',
      scannerFileName: '',
      scannerFile: '',
      scannerFileID: '',
      scannerFileSize: 0,
      scannerFolderId: '',
      scannerFileExtension: '',
      scannerFileNameSave: '',
      resultExMSG: '',
      bizFileContent: '',
      bizFileName: '',
      bizFile: '',
      bizFileID: '',
      bizFileSize: 0,
      bizFolderId: '',
      bizFileExtension: '',
      bizFileNameSave: '',
      resultMSG: '',
      buildResultMSG: '',
      /* 2020/11/11 203737 Remove unused source
    executeResultMSG:'',*/
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      validateMessage: '',
      isSaved: false,
      items: [
        { tab: 'repository', content: 'Repository' },
        { tab: 'srm_list', content: 'SRM List' },
      ],
      /* 2020/11/11 203737 Remove unused source
    queryFolderList: {
      header: [ 'USER_ID'],
      data: [{
        USER_ID:'',
      }],
    },
    queryFileList: {
      header: [ 'USER_ID','FOLD_ID'],
      data: [{
        USER_ID:'',
        FOLD_ID:'',
      }],
    },*/
      saveItemsParams: {
        header: [
          'SYSSTATUS',
          'USER_ID',
          'FOLD_ID',
          'FILE_ID',
          'USR_FILE_NAME',
          'USR_FILE_SIZE',
          'USR_FILE_TYPE',
          'USR_FILE_KIND',
        ],
        data: [],
      },
      buildItemsParams: {
        header: ['FILE_ID', 'MAP_TYPE', 'LIB_VER', 'ORA_VER'],
        data: [],
      },
      exeItemsParams: {
        header: ['IN_FILE_ID', 'EX_FILE_ID', 'MAP_TYPE', 'LIB_VER', 'ORA_VER', 'CODE_CTG_ID'],
        data: [],
      },
      exeToFlatItemsParams: {
        header: ['IN_FILE_ID', 'SCAN_TYPE', 'STDDB_VER'],
        data: [],
      },
      librarySearchItem: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      libraryItem: [],
      libraryVersion: '',
      oracleVersion: '',
      standardDB: '',
      isDlb: false,
      loadTypes: [
        { text: 'Load From Local', value: 'local' },
        { text: 'Load From Server', value: 'server' },
      ],
      checkInYN: '',
      currenVersionData: null,
      version: '',
    };
  },

  created() {
    EventBus.$on('updateScannerStatus', this.updateScannerStatus);
    this.getLibraryVersion();
    this.tooltipWidth = cfg.tooltipWidth;
    this.isDlb = cfg.isDlb;
    if (this.scannerList.length > 0) {
      this.scannerFileName = this.scannerList[0].SCANNER_NAME;
      this.scannerFileNameSave = this.scannerList[0].SCANNER_NAME;
      Store.dispatch('common/viewFileData', this.scannerList[0].FILE_ID).then(() => {
        this.scannerFileContent = this.fileContent;
      });
    }
    this.clearMovedData();
  },
  mounted() {},
  watch: {
    checkInYN() {
      if (this.checkInYN === '') {
        this.$emit('changeScannerVersionHistoryItem', null);
      }
    },
    versionList() {
      this.currenVersionData = this.versionList;
    },
  },
  methods: {
    clearTab() {
      this.clearView('input');
      this.clearView('scanner');
      this.clearView('biz');
    },
    clearMovedData() {
      var flag = 'N';
      Store.dispatch('mapbuilder/clearMovedData', flag);
    },
    onVersionChange(libver) {
      // console.log(JSON.stringify(this.libList))
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
      console.log(this.oracleVersion);
    },
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('mapbuilder/queryLibraryList', this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if (this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE,
            });
            this.standardDB = this.libList[0].SITE_DB_PATH;
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE,
              });
              this.standardDB = this.libList[i].SITE_DB_PATH;
            }
          }
        }
        this.libraryVersion = this.libraryItem[0].value;
        this.onVersionChange(this.libraryVersion);
      });
    },
    saveInputFile() {
      console.log('-------SaveNewInFile--------');
      // FileName blank
      if (this.inputFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'input' });
        return;
      }
      // FileName not blank
      else {
        if (this.inputFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Input Data Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.inputFolderId;
          savefile.FILE_ID = this.fileID;
          savefile.USR_FILE_NAME = this.inputFile.name;
          //203665 2020/11/13 fix common issue 17
          // savefile.USR_FILE_SIZE = this.inputFile.size
          savefile.USR_FILE_SIZE = new Blob([this.inputFileContent]).size;
          savefile.USR_FILE_TYPE = this.inputFileExtension;
          savefile.USR_FILE_KIND = 'IN';
          savefile.file = this.inputFileContent;
          this.saveItemsParams.data[0] = savefile;
          console.log('------this is update-----');
          Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
            this.fileID = this.savedFile[0].FILE_NAME;
            this.$refs.input_data.value = null;
          });
        }
      }
    },
    saveScannerFile() {
      // FileName blank
      if (this.scannerFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'scanner' });
        return;
      }
      // FileName not blank
      else {
        if (this.scannerFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Scanner Data Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.scannerFolderId;
          savefile.FILE_ID = this.scannerFileID;
          savefile.USR_FILE_NAME = this.scannerFileName;
          //203665 2020/11/13 fix common issue 17
          // savefile.USR_FILE_SIZE = this.scannerFileSize;
          savefile.USR_FILE_SIZE = new Blob([this.scannerFileContent]).size;
          savefile.USR_FILE_TYPE = 'cpp';
          savefile.USR_FILE_KIND = 'SCN';
          savefile.file = this.scannerFileContent;
          this.saveItemsParams.data[0] = savefile;
          console.log('this is update----------->');
          Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
            this.scannerFileID = this.savedFile[0].FILE_NAME;
            this.isSaved = true;
            this.$refs.scanner_data.value = null;
          });
        }
      }
    },
    saveBizFile() {
      // FileName blank
      if (this.bizFileName === '') {
        this.openLoadFilePop({ mode: 'Save', filetype: 'biz' });
        return;
      }
      // FileName not blank
      else {
        if (this.bizFileContent.toString().trim() == '') {
          this.validateMessage = this.$t('msg.common.require', ['Biz Data Content']);
          this.$refs.validateDialog.dialog = true;
          return;
        } else {
          let savefile = {};
          savefile.SYSSTATUS = 'U';
          savefile.USER_ID = $cookies.get('user-id');
          savefile.FOLD_ID = this.bizFolderId;
          savefile.FILE_ID = this.bizFileID;
          savefile.USR_FILE_NAME = this.bizFileName;
          //203665 2020/11/13 fix common issue 17
          // savefile.USR_FILE_SIZE = this.bizFile.size
          savefile.USR_FILE_SIZE = new Blob([this.bizFileContent]).size;
          savefile.USR_FILE_TYPE = this.bizFileExtension;
          savefile.file = this.bizFileContent;
          savefile.USR_FILE_KIND = 'BIZ';
          this.saveItemsParams.data[0] = savefile;
          console.log('this is update----------->');
          Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
            this.bizFileID = this.savedFile[0].FILE_NAME;
          });
        }
      }
    },
    buildScanner() {
      if (this.scannerFileContent.toString().trim() == '') {
        this.validateMessage = this.$t('msg.common.require', ['ScannerFile Id']);
        this.$refs.validateDialog.dialog = true;
        return;
      } else {
        let savefile = {};
        savefile.SYSSTATUS = 'U';
        savefile.USER_ID = $cookies.get('user-id');
        savefile.FOLD_ID = this.scannerFolderId;
        savefile.FILE_ID = this.scannerFileID;
        savefile.USR_FILE_NAME = this.scannerFileName;
        //203665 2020/11/13 fix common issue 17
        // savefile.USR_FILE_SIZE = this.scannerFileSize;
        savefile.USR_FILE_SIZE = new Blob([this.scannerFileContent]).size;
        savefile.USR_FILE_TYPE = 'cpp';
        savefile.USR_FILE_KIND = 'SCN';
        savefile.file = this.scannerFileContent;
        this.saveItemsParams.data[0] = savefile;
        console.log('this is update----------->');
        Store.dispatch('mapbuilder/saveWorkSpaceMapFile', this.saveItemsParams).then(() => {
          this.scannerFileID = this.savedFile[0].FILE_NAME;
          this.isSaved = true;
          this.$refs.scanner_data.value = null;

          this.buildItemsParams.data[0] = {
            FILE_ID: this.scannerFileID,
            MAP_TYPE: 'SCAN',
            LIB_VER: this.libraryVersion,
            ORA_VER: this.oracleVersion,
          };
          Store.dispatch('mapbuilder/mapBuild', this.buildItemsParams).then(() => {
            console.log('--------- Finished to process Build ----------');
            this.resultMSG = this.buildResult[0].RESULT + '\r\n' + this.buildResult[0].MSG;
            this.buildResultMSG = this.buildResult[0].RESULT;
          });
        });
      }
    },
    executeScannner() {
      console.log('-------Execute--------');
      //203665 2020-10-09 CLV Clear output when execute [issue 22 MapBuilder]
      this.bizFileContent = '';
      this.bizFileName = '';
      this.bizFile = '';
      this.bizFileID = '';
      this.bizFileSize = 0;
      this.bizFolderId = '';
      this.bizFileExtension = '';
      this.bizFileNameSave = '';
      if (this.scannerFileID == '' || this.fileID == '') {
        this.validateMessage = this.$t('msg.mapBuilder.executeWarning');
        this.$refs.validateDialog.dialog = true;
        return;
      }
      this.exeItemsParams.data[0] = {
        IN_FILE_ID: this.fileID,
        EX_FILE_ID: this.scannerFileID,
        MAP_TYPE: 'SCAN',
        LIB_VER: this.libraryVersion,
        ORA_VER: this.oracleVersion,
        CODE_CTG_ID: '',
      };
      Store.dispatch('mapbuilder/mapExecute', this.exeItemsParams).then(() => {
        console.log('--------- Finished to process Execute ----------');
        if (this.exeResult[0].RESULT == 'FAIL') {
          this.resultMSG = this.exeResult[0].RESULT + '\r\n' + this.exeResult[0].MSG;
          this.disableCheckin = true;

          this.accessCheckIn = false;
        } else {
          this.resultMSG = this.exeResult[0].RESULT;
          this.bizFileContent = this.exeResult[0].MSG;
          this.disableCheckin = false;
          this.accessCheckIn = true;
        }
      });
    },
    executeToFlat() {
      if (this.fileID == '') {
        this.validateMessage = this.$t('msg.mapBuilder.executeWarning');
        this.$refs.validateDialog.dialog = true;
        return;
      }

      if (this.scannerType === 'ediscanner_x12') {
        this.scannerType = 'ediscanner';
      }

      this.exeToFlatItemsParams.data[0] = {
        IN_FILE_ID: this.fileID,
        SCAN_TYPE: this.scannerType,
        STDDB_VER: this.standardDB,
      };
      Store.dispatch('mapbuilder/exeAlgetaScanner', this.exeToFlatItemsParams).then(() => {
        console.log('--------- Finished to process Execute ----------');
        if (this.exeResult[0].RESULT == 'FAIL') {
          this.resultExMSG = this.exeResult[0].RESULT + '\r\n' + this.exeResult[0].MSG;
        } else {
          this.resultExMSG = this.exeResult[0].RESULT;
          this.bizFileContent = this.exeResult[0].MSG;
        }
      });
    },
    loadInputLocal() {
      this.$refs.input_data.click();
    },
    inputDataFileLocal(e) {
      //203665 2020-10-09 CLV Reset when load form local [issue 24 MapBuilder]
      (this.inputFileName = ''), //CLEAR FILE NAME WHEN LOAD LOCAL
        (this.fileID = ''),
        (this.inputFile = e.target.files[0]);
      this.inputFileExtension = e.target.files[0].name.split('.').pop();
      this.inputFileNameSave = e.target.files[0].name;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.inputFileContent = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    loadScannerLocal() {
      this.$refs.scanner_data.click();
    },
    inputScannerFileLocal(e) {
      (this.scannerFileName = ''), //CLEAR FILE NAME WHEN LOAD LOCAL
        (this.scannerFileSize = e.target.files[0].size);
      this.scannerFile = e.target.files[0];
      this.scannerFileExtension = e.target.files[0].name.split('.').pop();
      this.scannerFileNameSave = e.target.files[0].name;
      this.resultMSG = '';
      this.buildResultMSG = '';
      this.scannerFileID = '';
      this.disableCheckin = true;
      this.checkInYN = '';
      this.isSaved = false;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.scannerFileContent = reader.result;
      };
      reader.readAsText(e.target.files[0]);
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      if (mode == 'Load') {
        let callback = (row) => {
          Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {
            if (filetype == 'input') {
              this.$refs.input_data.value = null;
              //203665 2020-10-09 CLV Convert  to string data [issue 25 MapBuilder]
              if (typeof this.fileContent === 'object') {
                this.inputFileContent = JSON.stringify(this.fileContent, null, '\t');
              } else {
                this.inputFileContent = this.fileContent.toString();
              }
              this.fileID = row.FILE_ID;
              this.inputFileName = row.USR_FILE_NAME;
              this.inputFileNameSave = row.USR_FILE_NAME;
              this.inputFileSize = row.USR_FILE_SIZE;
              this.inputFileExtension = row.USR_FILE_TYPE;
              this.inputFolderId = row.FOLD_ID;
              this.lastFoldIdInput = row.FOLD_ID;
            } else if (filetype == 'scanner') {
              this.$refs.scanner_data.value = null;
              //203665 2020-10-09 CLV Convert  to string data [issue 25 MapBuilder]
              if (typeof this.fileContent === 'object') {
                this.scannerFileContent = JSON.stringify(this.fileContent, null, '\t');
              } else {
                this.scannerFileContent = this.fileContent.toString();
              }
              this.scannerFileID = row.FILE_ID;
              this.scannerFileName = row.USR_FILE_NAME;
              this.scannerFileNameSave = row.USR_FILE_NAME;
              this.scannerFileSize = row.USR_FILE_SIZE;
              this.scannerFileExtension = row.USR_FILE_TYPE;
              this.scannerFolderId = row.FOLD_ID;
              this.resultMSG = '';
              this.buildResultMSG = '';
              this.isSaved = true;
              this.disableCheckin = true;
              this.lastFoldIdScanner = row.FOLD_ID;
              this.checkInYN = '';
            }
          });
        };
        this.$emit('openLoadFile', {
          mode: 'Load',
          filetype: filetype,
          lastFoldIdInput: this.lastFoldIdInput,
          lastFoldIdScanner: this.lastFoldIdScanner,
          callback,
        });
      }
      if (mode == 'Save') {
        let callback = (row) => {
          if (filetype == 'input') {
            this.$refs.input_data.value = null;
            this.inputFileContent = row.file;
            this.fileID = row.FILE_ID;
            this.inputFileName = row.USR_FILE_NAME;
            this.inputFileNameSave = row.USR_FILE_NAME;
            this.inputFileSize = row.USR_FILE_SIZE;
            this.inputFileExtension = row.USR_FILE_TYPE;
            this.inputFolderId = row.FOLD_ID;
            this.lastFoldIdInput = row.FOLD_ID;
          } else if (filetype == 'scanner') {
            this.$refs.scanner_data.value = null;
            this.scannerFileContent = row.file;
            this.scannerFileID = row.FILE_ID;
            this.scannerFileName = row.USR_FILE_NAME;
            this.scannerFileNameSave = row.USR_FILE_NAME;
            this.scannerFileSize = row.USR_FILE_SIZE;
            this.scannerFileExtension = row.USR_FILE_TYPE;
            this.scannerFolderId = row.FOLD_ID;
            this.lastFoldIdScanner = row.FOLD_ID;
            this.isSaved = true;
          } else if (filetype == 'biz') {
            this.bizFileName = row.USR_FILE_NAME;
            this.bizFileNameSave = row.USR_FILE_NAME;
            this.bizFileContent = row.file;
            this.bizFileID = row.FILE_ID;
            this.bizFileSize = row.USR_FILE_SIZE;
            this.bizFileExtension = row.USR_FILE_TYPE;
            this.bizFolderId = row.FOLD_ID;
          }
        };
        let content = [];
        if (filetype == 'input') {
          content.push(this.inputFileContent);
          if (this.inputFileExtension == '') {
            this.inputFileExtension = 'txt';
          }
          content.push(this.inputFileExtension);
          content.push(this.inputFileNameSave);
          content.push('IN');
        } else if (filetype == 'scanner') {
          content.push(this.scannerFileContent);
          if (this.scannerFileExtension == '') {
            this.scannerFileExtension = 'cpp';
          }
          content.push(this.scannerFileExtension);
          content.push(this.scannerFileNameSave);
          content.push('SCN');
        } else if (filetype == 'biz') {
          content.push(this.bizFileContent);
          if (this.bizFileExtension == '') {
            this.bizFileExtension = 'txt';
          }
          content.push(this.bizFileExtension);
          content.push(this.bizFileNameSave);
          content.push('BIZ');
        }
        // this.$emit('openLoadFile', {mode : 'Save', filetype: filetype ,content, callback});
        this.$emit('openLoadFile', {
          mode: 'Save',
          filetype: filetype,
          content,
          lastFoldIdInput: this.lastFoldIdInput,
          lastFoldIdScanner: this.lastFoldIdScanner,
          callback,
        });
      }
    },
    openScannerListDialog() {
      this.$emit('openScannerListDialog');
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item: item.item };
      return { id, name, type, options };
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    // 203705 mapbuilder fix issues 21
    clearView(type) {
      if (type == 'input') {
        this.inputFileName = '';
        this.inputFileContent = '';
        this.fileID = '';
        this.disableCheckin = '';
        this.checkInYN = '';
        this.inputFileNameSave = '';
        this.inputFileExtension = '';
        this.inputFile = '';
      } else if (type === 'scanner' || type == 'ediScanner') {
        this.scannerFileName = '';
        this.scannerFileContent = '';
        this.resultExMSG = '';
        this.scannerFileID = '';
        this.resultMSG = '';
        this.buildResultMSG = '';
        this.disableCheckin = '';
        this.checkInYN = '';
        this.scannerFileNameSave = '';
        this.inputFileExtension = '';
        this.inputFile = '';
        this.version = '';
        const query = this.$route.query;
        if (query.tab == 'Scanner') {
          this.$router.push({
            query: {
              tab: 'Scanner',
            },
          });
        }
      } else if (type === 'biz') {
        this.bizFileName = '';
        this.bizFileContent = '';
        this.bizFileNameSave = '';
        this.bizFileID = '';
        this.bizFileSize = '';
      }
    },
    onChangeTextView(type) {
      if (type == 'input') {
        this.$refs.input_data.value = null;
      } else if (type === 'scanner') {
        this.$refs.scanner_data.value = null;
      }
    },
    expandView(type) {
      if (type == 'input') {
        this.$refs.inputFile.cminstance.setOption('fullScreen', true);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'InputData File',
          iconClass: 'icon-collapse',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'input-add-row' });
        $('.zoom-input-data .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse').on('click', { type: 'input' }, this.closeExpand);
      } else if (type === 'scanner' || type == 'ediScanner') {
        this.$refs.scannerFile.cminstance.setOption('fullScreen', true);
        //Close another view
        $('.biz-add-row').remove();
        $('.input-add-row').remove();
        this.$refs.bizFile.cminstance.setOption('fullScreen', false);
        this.$refs.inputFile.cminstance.setOption('fullScreen', false);
        //Create label, button close expand view
        var div = document.createElement('div');
        if (type == 'scanner') {
          div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
            title: 'Scanner File',
            iconClass: 'icon-collapse-scanner',
          });
        } else {
          div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
            title: 'Result of compile or execution',
            iconClass: 'icon-collapse-scanner',
          });
        }
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'scanner-add-row' });
        $('.zoom-scanner-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-scanner').on('click', { type: 'scanner' }, this.closeExpand);
      } else if (type === 'biz') {
        this.$refs.bizFile.cminstance.setOption('fullScreen', true);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Biz File',
          iconClass: 'icon-collapse-biz',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'biz-add-row' });
        $('.zoom-biz-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-collapse-biz').on('click', { type: 'biz' }, this.closeExpand);
      } else if (type === 'resultBuild') {
        this.$refs.resultBuild.cminstance.setOption('fullScreen', true);
        //Close another view
        $('.input-add-row').remove();
        $('.biz-add-row').remove();
        this.$refs.bizFile.cminstance.setOption('fullScreen', false);
        this.$refs.inputFile.cminstance.setOption('fullScreen', false);
        //Create label, button close expand view
        var div = document.createElement('div');
        div.innerHTML = this.$t('msg.mapBuilder.addLabelHtml', {
          title: 'Result of compile or execution',
          iconClass: 'icon-build-result',
        });
        div.className = this.$t('msg.mapBuilder.addRowClass', { rowClass: 'scanner-add-row' });
        $('.zoom-scanner-file .CodeMirror-fullscreen').prepend(div);
        $('.icon-build-result').on('click', { type: 'scanner' }, this.closeExpand);
      }
    },
    closeExpand(e) {
      if (e.data.type == 'input') {
        $('.input-add-row').remove();
        this.$refs.inputFile.cminstance.setOption('fullScreen', false);
      } else if (e.data.type == 'scanner') {
        $('.scanner-add-row').remove();
        this.$refs.scannerFile.cminstance.setOption('fullScreen', false);
        if (typeof this.$refs.resultBuild !== 'undefined') {
          this.$refs.resultBuild.cminstance.setOption('fullScreen', false);
        }
      } else if (e.data.type == 'biz') {
        $('.biz-add-row').remove();
        this.$refs.bizFile.cminstance.setOption('fullScreen', false);
      }
    },
    openScannerCheckInDialog() {
      if (this.accessCheckIn == false) {
        this.validateMessage = this.$t('msg.mapBuilder.noSuccessExecute');
        this.$refs.validateDialog.dialog = true;
        return;
      }
      let dataCheckIn = [];
      dataCheckIn.push(this.scannerFileID);
      dataCheckIn.push(this.scannerFileContent);
      dataCheckIn.push(this.scannerFileSize);
      dataCheckIn.push(this.libraryVersion);
      this.$emit('openScannerLayoutCheckIn', dataCheckIn);
    },
    updateScanner(data) {
      this.$refs.scanner_data.value = null;
      this.scannerFileContent = data.fileContent;
      this.scannerFileName = data.SCANNER_NAME;
      this.scannerFileNameSave = data.SCANNER_NAME;
      this.scannerFileID = '';
      this.scannerFileSize = data.SCANNER_SIZE;
      this.resultMSG = '';
      this.buildResultMSG = '';
      this.isSaved = false;
      this.disableCheckin = true;
      this.version = data.SCAN_VER;
    },
    // 2022.01.13 213960 SPKA-365 Group 2 buttons to v-menu
    changeLoadType(type) {
      if (type.value === 'local') {
        this.loadScannerLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'scanner' });
      }
    },
    changeLoadInputType(type) {
      if (type.value === 'local') {
        this.loadInputLocal();
      } else {
        this.openLoadFilePop({ mode: 'Load', filetype: 'input' });
      }
    },
    openCheckOut() {
      this.$refs.checkOutDialog.dialog = true;
    },

    onClickOkay() {
      let lockItems = {
        header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
        data: [
          {
            MAP_KIND: '',
            MAP_PRCS_NO: '',
            LOCK_YN: '',
          },
        ],
      };
      lockItems.data[0].MAP_KIND = 'SCAN';
      lockItems.data[0].MAP_PRCS_NO = this.currenVersionData.MAP_PRCS_NO;
      lockItems.data[0].LOCK_YN = 'Y';
      console.log(lockItems);
      Store.dispatch('map/updateLock', lockItems).then(() => {
        this.checkInYN = 'Y';
        console.log('--------- Finished to process CHECKOUT ----------');
      });
    },
    updateScannerStatus(status) {
      this.checkInYN = status;
    },
  },
};
</script>

<style>
.pl-12px {
  padding-left: 12px !important;
}
.pr-12px {
  padding-right: 12px !important;
}
.scanner-grid-pd {
  height: 680px;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 20px 15px 15px 15px !important;
}
.text-view-biz {
  border: 1px solid #7d838d;
  box-sizing: border-box;
  margin-top: 0px;
}
.text-view-scanner {
  /* border: 1px solid #7D838D; */
  box-sizing: border-box;
  margin-top: 0px;
  margin-bottom: 5px;
}
.text-view-input {
  /* border: 1px solid #7D838D; */
  box-sizing: border-box;
  margin-top: 0px;
}
.text-view-ediscanner {
  border: 1px solid #7d838d;
  box-sizing: border-box;
  margin-top: 0px;
  margin-bottom: 5px;
}
.build-result-view {
  border: 1px solid #7d838d;
  box-sizing: border-box;
  margin-top: 0px;
  margin-bottom: 5px;
}
/* 2022.01.13 213960 SPKA-365 Modify light version for Map Builder */
.text-view-input .CodeMirror {
  height: 495px !important;
}
.text-view-scanner .CodeMirror {
  height: 290px !important;
}
.text-view-ediscanner .CodeMirror {
  height: 495px !important;
}
.build-result-view .CodeMirror {
  height: 137px !important;
}
.text-view-biz .CodeMirror {
  height: 495px !important;
}
.scanner-label {
  font-weight: bold;
  font-size: 18px;
  line-height: 30px;
  display: flex;
  align-items: center;
  letter-spacing: 0.5px;
}
/* .theme--light .scanner-label{
  color: #BA0070;
} */
.theme--dark .scanner-label {
  color: #dfe1e5;
}
.scanner-grid-pd .v-textarea .v-input__control {
  height: 133px;
}
.scanner-grid-pd .v-textarea .v-input__control .v-input__slot {
  margin-bottom: 0px;
}
.btn-form-control button.btn-scanner.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 5px !important;
}
.scanner-icon {
  justify-content: flex-end;
  margin-bottom: 0px;
  position: relative;
}
.btn-expand {
  margin-bottom: 2px;
}
.edi-scanner-row {
  margin-top: 50px;
}
.edi-scanner-label {
  font-weight: bold;
  font-size: 18px;
  line-height: 30px;
}
.theme--dark .edi-scanner-label {
  color: #ffffff;
}
.theme--light .edi-scanner-label {
  color: #4c4f5a;
}
.scanner-grid-pd .v-grid-title .v-input__slot {
  height: 30px;
  line-height: 30px;
  padding-left: 14px;
}
.theme--light .scanner-grid-pd .date-query-section .v-input__slot {
  border: 1px solid #cedeff;
  box-sizing: border-box;
  border-radius: 3px;
}
.theme--light .scanner-icon .v-btn.v-btn--icon {
  background-color: #ffffff;
}
.theme--light .btn-execute span.v-btn__content {
  /* color:#FDFF86; */
  line-height: 16px;
}
.theme--light .scanner-grid-pd {
  background: #ffffff;
  /* border: 1px solid #349CD8; */
}
.theme--light .scanner-grid-pd .v-grid-title .v-input {
  background: #ffffff;
  padding: 0;
}
.theme--dark .scanner-grid-pd {
  background: #292c35;
  border: none;
}
.theme--dark .scanner-grid-pd .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
  padding: 0;
}
.theme--dark .scanner-grid-pd .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
  padding: 0;
  height: 30px !important;
}
.theme--dark .scanner-icon .v-btn.v-btn--icon {
  background-color: #333640;
}
.theme--dark .scanner-grid-pd .v-text-field--solo > .v-input__control > .v-input__slot {
  background: #2a2c35;
  box-sizing: border-box;
  /* border-radius: 3px; */
}
.theme--dark .btn-execute span.v-btn__content {
  color: #ffffff;
  line-height: 16px;
}
.scanner-grid-pd .btn-inline .v-btn__content {
  font-size: 13px;
}
.scanner-grid-pd .btn-inline {
  width: 120px;
  padding: 0 4px;
}
.scanner-grid-pd .CodeMirror-fullscreen {
  height: 90% !important;
  top: 50px;
  position: fixed;
}
.scanner-grid-pd .CodeMirror-lines {
  padding: 0px 0;
}
.scanner-grid-pd .CodeMirror-fullscreen .CodeMirror-vscrollbar {
  top: 28px;
  bottom: -14px !important;
}
.zoom-input-data .CodeMirror-fullscreen,
.zoom-m-biz-data .CodeMirror-fullscreen {
  left: 51%;
  width: 23%;
}
.zoom-scanner-file .CodeMirror-fullscreen,
.zoom-mapper-file .CodeMirror-fullscreen {
  left: 4%;
  width: 94%;
}
.zoom-biz-file .CodeMirror-fullscreen,
.zoom-output-file .CodeMirror-fullscreen {
  left: 74%;
  width: 24%;
}
.file-name {
  display: inline-block;
  height: 26px;
  line-height: 20px;
  background: none;
  /* border: 1px solid; */
  border-bottom: none;
  align-items: center;
  letter-spacing: 0.5px;
  font-weight: bold;
  /* font-size: 12px; */
  padding: 0 5px;
  position: absolute;
  left: 0;
  white-space: nowrap;
  max-width: calc(100% - 50px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.theme--dark .file-name {
  color: #f99dd4;
}
.theme--light .file-name {
  color: #ba0070;
}
.file-name-expand {
  display: table-cell;
  height: 20px;
  line-height: 20px;
  border: none;
  border-bottom: none;
  align-items: center;
  letter-spacing: 0.5px;
  font-weight: bold;
  font-size: 12px;
  padding: 0 5px;
}
.theme--dark .file-name-expand {
  color: #f99dd4;
}
.theme--light .file-name-expand {
  color: #ba0070;
}
.theme--dark .input-add-row,
.theme--dark .scanner-add-row,
.theme--dark .biz-add-row,
.theme--dark .m-biz-add-row,
.theme--dark .mapper-add-row,
.theme--dark .output-add-row,
.theme--dark .build-add-row {
  background: #1f4661;
}
.theme--light .input-add-row,
.theme--light .scanner-add-row,
.theme--light .biz-add-row .theme--light .m-biz-add-row,
.theme--light .mapper-add-row,
.theme--light .output-add-row,
.theme--light .build-add-row {
  background: #f7f7f7;
}
.disable-events {
  pointer-events: none;
}
.test {
  text-align: right;
  padding-left: 4px;
  padding-top: 4px;
  z-index: 10;
}
.icon-collapse,
.icon-collapse-scanner,
.icon-collapse-biz,
.icon-build-result,
.icon-collapse-m-biz,
.icon-collapse-mapper,
.icon-collapse-output {
  font-size: 12px;
}
.builder-section .CodeMirror-scroll {
  padding-bottom: 20px;
  margin-bottom: -20px;
}
.btn-edi-expand {
  -webkit-writing-mode: vertical-rl;
}
.btn-edi-expand .scanner-icon {
  display: grid;
}
.show-load-txt {
  display: contents;
}
.show-load-icon.v-icon {
  display: none;
}
.scanner-grid-pd .data-query-section .v-input {
  font-size: 14px;
}
.custom-menu > .v-list-item {
  min-height: 20px !important;
}
.custom-menu > .v-list-item > .v-list-item__content {
  padding: 6px !important;
}
</style>
